import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="relative bg-background-50 pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-80 h-80 rounded-full bg-primary-100/60 blur-3xl" />
        <div className="absolute top-40 right-1/4 w-72 h-72 rounded-full bg-accent-100/50 blur-3xl" />
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7 animate-rise">
            <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-100 border border-background-200 font-label text-xs text-foreground-700">
              <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                <i className="ri-radar-line text-[14px]"></i>
              </span>
              资讯聚合门户 · 分站特色导览
            </span>

            <h2 className="mt-6 font-heading text-3xl md:text-5xl lg:text-[3.4rem] font-bold text-foreground-950 leading-[1.25]">
              细看黑料网5分站特色
              <span className="block mt-2 text-primary-600">
                区别与不同，一眼看明白
              </span>
            </h2>

            <p className="mt-6 font-body text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
              进入黑料网5首页即可看清各分站的内容划分。分站与主站的区别、独立版块的玩法差异都摆在明面上，
              不需要反复试错。想先判断哪里适合自己，就先看黑料网5特色和专属区块，再决定追哪些方向，省得来回翻。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#compare"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-foreground-950 font-label text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                看分站区别
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-[16px]"></i>
                </span>
              </a>
              <a
                href="#blocks"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-background-300 bg-background-50 text-foreground-900 font-label text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                浏览专属区块
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-layout-grid-line text-[16px]"></i>
                </span>
              </a>
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-y-6 border-t border-background-200 pt-6">
              {heroStats.map((item) => (
                <div key={item.label} className="flex flex-col">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {item.value}
                  </span>
                  <span className="mt-1 font-label text-xs text-foreground-600">
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 animate-rise animate-rise-delay-2">
            <div className="relative">
              <div className="w-full aspect-[5/4] rounded-lg overflow-hidden border border-background-200 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20illustration%20of%20layered%20translucent%20information%20cards%20and%20tag%20ribbons%20floating%20above%20a%20warm%20cream%20background%2C%20amber%20and%20olive%20green%20accents%2C%20delicate%20thin%20line%20details%2C%20soft%20paper%20grain%20texture%2C%20generous%20negative%20space%2C%20minimal%20geometric%20composition%2C%20no%20text&width=1100&height=880&seq=hla5-hero-main&orientation=landscape"
                  alt="黑料网5 分站特色与区别导览示意图"
                  title="黑料网5 分站特色 区别 不同 导览"
                  className="w-full h-full object-top"
                />
              </div>

              <div className="absolute -bottom-6 left-4 sm:left-6 w-[240px] rounded-lg border border-background-200 bg-background-50 p-4">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className="ri-bookmark-3-line text-[16px]"></i>
                  </span>
                  <span className="font-label text-xs text-foreground-600">
                    本页导览
                  </span>
                </div>
                <p className="mt-3 font-body text-[13px] leading-relaxed text-foreground-800">
                  6 个内容方向入口 · 5 个对照维度 · 6 个专属板块
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}